export default __webpack_public_path__ + "static/media/mined.c7581c3c.svg";